import { type StyledFontAwesomeIcons } from '@shared/plugin/icons/types';
import {
  faAddressCard as farAddressCard,
  faBars as farBars,
  faBell as farBell,
  faBuilding as farBuilding,
  faCircleInfo as farCircleInfo,
  faClipboardListCheck as farClipboardListCheck,
  faFolderOpen as farFolderOpen,
  faGlobePointer as farGlobePointer,
  faGrid as farGrid,
  faHandshake as farHandshake,
  faMemo as farMemo,
  faMoneyCheckDollarPen as farMoneyCheckDollarPen,
  faNetworkWired as farNetworkWired,
  faSquareCode as farSquareCode,
  faUserGroup as farUserGroup,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faAddressCard as fasAddressCard,
  faBars as fasBars,
  faBell as fasBell,
  faBuilding as fasBuilding,
  faCircleInfo as fasCircleInfo,
  faClipboardListCheck as fasClipboardListCheck,
  faFolderOpen as fasFolderOpen,
  faGlobePointer as fasGlobePointer,
  faGrid as fasGrid,
  faHandshake as fasHandshake,
  faMemo as fasMemo,
  faMoneyCheckDollarPen as fasMoneyCheckDollarPen,
  faNetworkWired as fasNetworkWired,
  faSquareCode as fasSquareCode,
  faUserGroup as fasUserGroup,
} from '@fortawesome/pro-solid-svg-icons';

export const adviseurIcons = {
  algemeen: { regular: farBars, solid: fasBars },
  medewerkers: { regular: farUserGroup, solid: fasUserGroup },
  afdelingen: { regular: farNetworkWired, solid: fasNetworkWired },
  DVO: { regular: farHandshake, solid: fasHandshake },
  vergunningen: { regular: farClipboardListCheck, solid: fasClipboardListCheck },
  grootboeken: { regular: farMoneyCheckDollarPen, solid: fasMoneyCheckDollarPen },
  maatschappijen: { regular: farBuilding, solid: fasBuilding },
  log: { regular: farSquareCode, solid: fasSquareCode },
  logo: { regular: farAddressCard, solid: fasAddressCard },
  dossier: { regular: farFolderOpen, solid: fasFolderOpen },
  webmodules: { regular: farGlobePointer, solid: fasGlobePointer },
  overig: { regular: farGrid, solid: fasGrid },
  klantbeeld: { regular: farCircleInfo, solid: fasCircleInfo },
  memos: { regular: farMemo, solid: fasMemo },
  alerts: { regular: farBell, solid: fasBell },
} as const satisfies Record<string, StyledFontAwesomeIcons>;
